var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 24H3.7C1.7 24 0 22.4 0 20.4V6C0 4 1.6 2.4 3.7 2.4H4.9V1.2C4.9 0.5 5.4 0 6.1 0C6.8 0 7.3 0.5 7.3 1.2V2.4H14.6V1.2C14.6 0.5 15.1 0 15.8 0C16.5 0 17 0.5 17 1.2V2.4H18.2C20.4 2.4 22 4 22 6V20.4C22 22.4 20.4 24 18.3 24ZM2.4 10.8V20.4C2.4 21.1 2.9 21.6 3.6 21.6H18.3C19 21.6 19.5 21.1 19.5 20.4V10.8H2.4ZM2.4 8.4H19.5V6C19.5 5.3 19 4.8 18.3 4.8H17.1V6C17.1 6.7 16.6 7.2 15.9 7.2C15.2 7.2 14.7 6.7 14.7 6V4.8H7.3V6C7.3 6.7 6.8 7.2 6.1 7.2C5.4 7.2 4.9 6.7 4.9 6V4.8H3.7C3 4.8 2.4 5.3 2.4 6V8.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8eb8c4f81145a2fa02014b11a570a4ad.svg";
export { ForwardRef as ReactComponent };